module.exports = __webpack_public_path__ + "static/Katy-Ingle-c0fc71f7f57d40a5c761b1259980e186.jpg";